module.exports = __webpack_public_path__ + "static/view_6-140d403e482706f9b668d9ac0eb36d68.jpg";